export const pollData = [
	{
		id:1,
		name: "1",
		label:
			"¿Qué tan satisfecho(a) estás con la claridad de la información contable que se te proporcionó durante la reunión?",
		type: "radio",
	},
	{
		id:2,
		name: "2",
		label:
			"¿Sentiste que tus dudas o preguntas fueron respondidas de manera adecuada y comprensible?",
		type: "radio",
	},
	{
		id:3,
		name: "3",
		label:
			"¿Qué tan profesional fue el trato recibido por parte del asesor contable?",
		type: "radio",
	},
	{
		id:4,
		name: "4",
		label:
			"¿Qué tan satisfecho(a) estás con las soluciones o recomendaciones propuestas?",
		type: "radio",
	},
	{
		id:5,
		name: "5",
		label:
			"¿Qué tanto te ha ayudado la aplicación para gestionar tus archivos?",
		type: "radio",
	},
	{
		id:6,
		name: "6",
		label:
			"¿Hay algo que crees que se podría mejorar en futuras reuniones contables?",
		type: "text",
	},
];
